import WidgetAvgTime from './WidgetAvgTime';



export default WidgetAvgTime;
